import { createSlice } from "@reduxjs/toolkit";

export const TiersSlice = createSlice({
  name: "tiers",
  initialState: {
    level_tiers: [],
    fee_tiers: [],
  },
  reducers: {
    setLevelTiers: (state, action) => {
      state.level_tiers = action.payload["level_tiers"];
    },
    setFeeTiers: (state, action) => {
      state.fee_tiers = action.payload["fee_tiers"];
    },
  },
});
export const { setLevelTiers, setFeeTiers } = TiersSlice.actions;
export default TiersSlice.reducer;
